import { handleActions } from "redux-actions";
import { createReducer } from "../baseReducer/baseReducer";
import { api } from "api";
import { NotificationManager } from "react-notifications";
import moment from "moment";

// ------------------------------------
// Constants
// ------------------------------------
const FILTER_BY_STATION_EMERGENCY_REPORT_DETAIL =
    "FILTER_BY_STATION_EMERGENCY_REPORT_DETAIL";
const FILTER_BY_START_DATE_EMERGENCY_REPORT_DETAIL =
    "FILTER_BY_START_DATE_EMERGENCY_REPORT_DETAIL";
const FILTER_BY_END_DATE_EMERGENCY_REPORT_DETAIL =
    "FILTER_BY_END_DATE_EMERGENCY_REPORT_DETAIL";
const FILTER_BY_TYPE_EMERGENCY_EMERGENCY_CATEGORY_REPORT_DETAIL =
    "FILTER_BY_TYPE_EMERGENCY_EMERGENCY_CATEGORY_REPORT_DETAIL";
const FILTER_BY_TYPE_EMERGENCY_EMERGENCY_REPORT_DETAIL =
    "FILTER_BY_TYPE_EMERGENCY_EMERGENCY_REPORT_DETAIL";
const FILTER_BY_REGION_EMERGENCY_REPORT_DETAIL =
    "FILTER_BY_REGION_EMERGENCY_REPORT_DETAIL";

const setFilterByStation = (station) => ({
    type: FILTER_BY_STATION_EMERGENCY_REPORT_DETAIL,
    station,
});

const setOptionsRegion = (region) => ({
    type: FILTER_BY_REGION_EMERGENCY_REPORT_DETAIL,
    region,
});

const setFilterByStartDate = (start_date) => ({
    type: FILTER_BY_START_DATE_EMERGENCY_REPORT_DETAIL,
    start_date,
});

const setFilterByEndDate = (end_date) => ({
    type: FILTER_BY_END_DATE_EMERGENCY_REPORT_DETAIL,
    end_date,
});

const setFilterByTypeEmergency = (emergency_type_id) => ({
    type: FILTER_BY_TYPE_EMERGENCY_EMERGENCY_REPORT_DETAIL,
    emergency_type_id,
});

const setFilterByTypeEmergencyCategory = (emergency_type_category) => ({
    type: FILTER_BY_TYPE_EMERGENCY_EMERGENCY_CATEGORY_REPORT_DETAIL,
    emergency_type_category,
});

const setExcelLoading = (payload) => ({
    type: 'SET_EXCEL_LOADING',
    payload,
});

const setExcelProgress = (payload) => ({
    type: 'SET_EXCEL_PROGRESS',
    payload,
});

export const baseReducer = createReducer(
    "emergency_report_detail",
    "reports/emergency_report_detail",
    "ListReportEmergenciesDetail"
);

const descargarExcel = () => (dispatch, getStore) => {
    const resource = getStore()["emergency_report_detail"];

    // filter emergency type
    const emergency_type_id = resource.emergency_type_id
        ? resource.emergency_type_id.map((emergency_type_id) => emergency_type_id.id)
        : "";

    // filter emergency category
    const emergency_type_category = resource.emergency_type_category
        ? resource.emergency_type_category.map((emergency_type_category) => emergency_type_category.id)
        : "";

    const emergency_type_category_name = resource.emergency_type_category
        ? resource.emergency_type_category.map((emergency_type_category_name) => emergency_type_category_name.name)
        : "";

    const emergency_type_name = resource.emergency_type_id
        ? resource.emergency_type_id.map((emergency_type_name) => emergency_type_name.name)
        : "";

    // filter station
    const station_id = resource.station
        ? resource.station.map((station) => station.id)
        : "";

    // filter start date
    const start_date = resource.start_date
        ? moment(resource.start_date).format("YYYY-MM-DD")
        : "";
    // filter end date
    const end_date = resource.end_date
        ? moment(resource.end_date).format("YYYY-MM-DD")
        : "";

    // Filter by region
    const region_ = resource.region;

    const params = {
        station: station_id,
        emergency_type_category_name,
        emergency_type_category,
        emergency_type_id,
        start_date,
        end_date,
        region_type: region_,
        emergency_type_name
    };

    dispatch(setExcelLoading(true));
    dispatch(setExcelProgress(0));

    // Dynamic Filename Generation
    try {
        const { me } = getStore().login;
        let username = "Usuario";
        let roleName = "Rol";
        const dateStr = moment().format("YYYY-MM-DD_HH-mm");

        // Roles Map (copied to avoid import issues)
        const ROLES_MAP = {
            1: 'Administrador',
            5: 'Comandante',
            7: 'JefeDeServicio',
            8: 'Cabinista',
            10: 'Bombero',
            11: 'RecursosHumanos'
        };

        if (me) {
            // Username
            if (me.first_name || me.last_name) {
                username = `${me.first_name || ''}${me.last_name || ''}`.replace(/ /g, "");
            } else if (me.username) {
                username = me.username;
            }

            // Role
            if (me.role_configuration && me.role_configuration.name) {
                roleName = me.role_configuration.name.replace(/ /g, "");
            } else if (me.role) {
                roleName = (ROLES_MAP[me.role] || "Sistema").replace(/ /g, "");
            }
        }

        var filename = `ReporteDetallado_${username}_${roleName}_${dateStr}.xlsx`;
    } catch (e) {
        console.error("Error generating filename", e);
        var filename = `ReporteDetallado_emergencias.xlsx`;
    }

    api.getWithProgress("reports/excel_emergency_detail", params, (percent) => {
        dispatch(setExcelProgress(percent));
    })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(() => {
            NotificationManager.error('Error al descargar', 'ERROR');
        }).finally(() => {
            dispatch(setExcelLoading(false));
            dispatch(setExcelProgress(0));
        });
};

const listarReport =
    (page = 1) =>
        (dispatch, getStore) => {
            const resource = getStore()["emergency_report_detail"];
            const params = { page };

            // filter emergency type
            const emergency_type_id = resource.emergency_type_id
                ? resource.emergency_type_id.map((emergency_type_id) => emergency_type_id.id)
                : "";
            params.emergency_type_id = emergency_type_id;

            // filter emergency category
            const emergency_type_category = resource.emergency_type_category
                ? resource.emergency_type_category.map((emergency_type_category) => emergency_type_category.id)
                : "";
            params.emergency_type_category = emergency_type_category;

            // filter station
            const station_id = resource.station
                ? resource.station.map((station) => station.id)
                : "";
            params.station = station_id;

            // filter start date
            const start_date = resource.start_date
                ? moment(resource.start_date).format("YYYY-MM-DD")
                : "";
            params.start_date = start_date;
            // filter end date
            const end_date = resource.end_date
                ? moment(resource.end_date).format("YYYY-MM-DD")
                : "";
            params.end_date = end_date;

            if (start_date && end_date)
                if (end_date < start_date)
                    return NotificationManager.error(
                        "La fecha inicial no puede ser mayor a la fecha final",
                        "ERROR",
                        0
                    );

            // Filter by region
            const region_ = resource.region;
            params.region_type = region_;

            dispatch(baseReducer.actions.setLoader(true));
            api.get("reports/emergency_report_detail_data", params)
                .then((response) => {
                    // response contains data_1, data_2, data_3
                    dispatch(baseReducer.actions.setData(response));
                    dispatch(baseReducer.actions.setPage(page));
                })
                .catch(() => { })
                .finally(() => {
                    dispatch(baseReducer.actions.setLoader(false));
                });
        };

const setRegion = (value) => (dispatch) => {
    if (value === null) {
        value = "";
    }
    dispatch(setOptionsRegion(value));
    dispatch(listarReport());
};

const setStation = (value) => (dispatch, getStore) => {
    dispatch(setFilterByStation(value));
    dispatch(listarReport());
};

const setTypeEmergencyCategory = (value) => (dispatch, getStore) => {
    dispatch(setFilterByTypeEmergencyCategory(value));
    dispatch(listarReport());
};

const setTypeEmergency = (value) => (dispatch, getStore) => {
    dispatch(setFilterByTypeEmergency(value));
    dispatch(listarReport());
};

const setStartDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["emergency_report_detail"];
    dispatch(setFilterByStartDate(value));
    if (resource.end_date) dispatch(listarReport());
};

const setEndDate = (value) => (dispatch, getStore) => {
    const resource = getStore()["emergency_report_detail"];
    dispatch(setFilterByEndDate(value));
    if (resource.start_date) dispatch(listarReport());
};

export const actions = {
    listarReport,
    setRegion,
    setStation,
    setTypeEmergency,
    setTypeEmergencyCategory,
    setStartDate,
    setEndDate,
    descargarExcel,
    ...baseReducer.actions,
};

export const reducers = {
    ...baseReducer.reducers,
    [FILTER_BY_STATION_EMERGENCY_REPORT_DETAIL]: (state, { station }) => {
        return {
            ...state,
            station,
        };
    },
    [FILTER_BY_REGION_EMERGENCY_REPORT_DETAIL]: (state, { region }) => {
        return {
            ...state,
            region,
        };
    },
    [FILTER_BY_TYPE_EMERGENCY_EMERGENCY_REPORT_DETAIL]: (
        state,
        { emergency_type_id }
    ) => {
        return {
            ...state,
            emergency_type_id,
        };
    },
    [FILTER_BY_TYPE_EMERGENCY_EMERGENCY_CATEGORY_REPORT_DETAIL]: (
        state,
        { emergency_type_category }
    ) => {
        return {
            ...state,
            emergency_type_category,
        };
    },
    [FILTER_BY_START_DATE_EMERGENCY_REPORT_DETAIL]: (state, { start_date }) => {
        return {
            ...state,
            start_date,
        };
    },
    [FILTER_BY_END_DATE_EMERGENCY_REPORT_DETAIL]: (state, { end_date }) => {
        return {
            ...state,
            end_date,
        };
    },
    ['SET_EXCEL_LOADING']: (state, { payload }) => ({ ...state, excelLoading: payload }),
    ['SET_EXCEL_PROGRESS']: (state, { payload }) => ({ ...state, excelProgress: payload }),
};

export const initialState = {
    ...baseReducer.initialState,
    region: "",
    station: "",
    start_date: "",
    end_date: "",
    emergency_type_category: "",
    emergency_type_id: "",
    excelLoading: false,
    excelProgress: 0,
};

export default handleActions(reducers, initialState);
